import React, { useState, useEffect } from 'react'
import i18n from 'i18next'
import Button from '../../UniformComponents/Button'

const LockSlider = (props) => {
    const { editing } = props
    const [isChecked, setIsChecked] = useState(editing)

    const onChange = () => {
        if (isChecked) {
            props.edit(false)
            props.save()
        } else {
            props.edit()
        }
        setIsChecked(!isChecked)
    }

    useEffect(() => {
        setIsChecked(editing)
    }, [editing])

    return (
        <div className="lockSlider">
            <label className="lever">
                <input type="checkbox" checked={isChecked} onChange={onChange} />
                <span className="slidingBlock" />
                <div className="setting save">On</div>
                <div className="setting edit">Off</div>
            </label>
            {isChecked
                ? (
                    <Button
                        label={i18n.t('save')}
                        cssClass="secondary regular"
                        onClick={onChange}
                    />
                )
                : null}
        </div>
    )
}

export default LockSlider
